import { ProductExchangeRecommendationSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/product-exchange-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import * as z from "zod/v4";

export const getPersonalizedProductExchangeRecommendations = {
  name: "getPersonalizedProductExchangeRecommendations" as const,
  input: z.object({
    draftReturnId: z.string(),
    currentReturnProductId: z.string(),
    selectedProductsForReturn: z.array(ReturnProductSchema),
    returnReasons: z.array(ReturnReasonSchema),
  }),
  output: z.array(ProductExchangeRecommendationSchema),
};
